export enum UserPermissionEnum {
  LICENSE_MODULE = 'LICENSE_MODULE',
  GENERATE_PRODUCT_HTML = 'GENERATE_PRODUCT_HTML',
  AGENT_ONBOARDING = 'AGENT_ONBOARDING',
  CLIENT_ONBOARDING = 'CLIENT_ONBOARDING',
  SALES_OFFER_INTEGRATION_CONFIGURATION = 'SALES_OFFER_INTEGRATION_CONFIGURATION',
  MANAGE_USER_PERMISSIONS = 'MANAGE_USER_PERMISSIONS',
  SALES_ORDER_ACCESS = 'SALES_ORDER_ACCESS',
  PURCHASE_ORDER_ACCESS = 'PURCHASE_ORDER_ACCESS'
}